import React from "react";
import ReactDOM from "react-dom";
import "./globalStyle/globalStyle.scss";
import App from "./App";
import { Router, Switch } from "react-router-dom";
import history from "./utils/history";
import "../src/common/i18n";
import "./index.css";

ReactDOM.render(
  <React.StrictMode>
    <Router history={history}>
      <Switch>
        <App />
      </Switch>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);
